import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { Modal, Input } from 'antd-v5';
import TextAreaWithActions from '../../../../Layout/TextAreaWithActions';

import { notificationError, notificationSuccess } from '../../../../../core/actions';
import { postRequest, getRequest } from '../../../../../core/apiRequests';
import WhatsAppTimer from '../../../../Layout/WhatsAppTimer';
import useActionTextAreaFiles from '../../../../Layout/TextAreaWithActions/useActionTextAreaFiles';

const WhatsAppModal = props => {
  const [msgText, setMsgText] = useState('');
  const [fileData, fileDispatch] = useActionTextAreaFiles();
  const [configObj, setConfigObj] = useState({
    name: '',
    review: '',
    spouse: '',
  });
  const [reviewLink, setReviewLink] = useState('[Review Link]');

  useEffect(() => {
    let { storeId } = props.auth;
    if (props.auth.merchantId && props.auth.stores.length > 1) {
      if (!storeId) {
        storeId = props.auth.stores[1].id;
      }
      (async () => {
        const reqObj = {
          params: ['associates', props.auth.userId, storeId, 'reviewLink'],
        };
        const data = await getRequest(reqObj);
        if (data[0].review_link) {
          setReviewLink(data[0].review_link);
        }
      })();
    }
  }, [props.auth.merchantId, props.auth.userId, props.auth.stores]);

  useEffect(() => {
    if (props.auth.merchantId) {
      findSpouseName();
    }
  }, [props.auth.merchantId]);

  const sendMessage = () => {
    const { userId, merchantId, firstName, lastName } = props.auth;
    if (msgText.length || fileData.images.urls.length) {
      if (props.client_id && merchantId) {
        // clean message square brackets and dispatch message to backend
        const bodyData = {
          id: props.client_id,
          msg: msgText,
        };
        setMsgText('');
        const containsSubstring = substr => str => str.includes(substr);
        const reqObj = {
          params: ['chatMessages', merchantId, 'save'],
          query: {
            associateId: userId,
            s3Images: fileData.images.urls.filter(containsSubstring('s3.amazonaws.com')),
            s3Videos: fileData.videos.urls.filter(containsSubstring('s3.amazonaws.com')),
            fullName: `${firstName} ${lastName}`,
            storeId: props.store_id,
          },
          data: bodyData,
          images: {
            urls: fileData.images.urls.filter(containsSubstring('blob')),
            files: fileData.images.files,
          },
          videos: {
            urls: fileData.videos.urls.filter(containsSubstring('blob')),
            files: fileData.videos.files,
            videoFrames: fileData.videos.videoFrames,
          },
        };
        (async () => {
          const respData = await postRequest(reqObj);
          if (respData.id) {
            notificationSuccess('Message successfully sent!');
            // scrollToBottom();
            props.closeTheStuff();
          } else {
            notificationError('Failed To Send Message');
          }
        })();
      }
    } else {
      notificationError('Please Type A Message');
    }
  };

  const buttonHideCheck = () => {
    const findSpouse = props.client.relationships.filter(
      rltn => rltn.relationship == 'Husband' || rltn.relationship == 'Wife',
    );
    if (findSpouse.length === 0) {
      return ['spouse'];
    }
  };

  const findSpouseName = () => {
    const findSpouse = props.client.relationships.filter(
      rltn => rltn.relationship == 'Husband' || rltn.relationship == 'Wife' || rltn.relationship == 'Spouse',
    );
    if (findSpouse.length > 0) {
      setConfigObj({ ...configObj, spouse: findSpouse[0].related_client_name });
    }
  };

  // WHATSAPP

  const whatsAppReplacementFormatter = template => {
    const subsObj = {};
    if (template.substitution) {
      const substitutes = template.substitution.split(',');
      substitutes.forEach(sub => {
        const propertyDivide = sub.split('=');
        if ((propertyDivide.length = 2)) {
          subsObj[propertyDivide[0]] = propertyDivide[1].toLowerCase();
        }
      });
    }
    if (template.id) {
      return template.template.replace(/{{\d}}/g, val => {
        const theNumber = val.replace(/[{}]/g, '');
        if (props.inputObj[theNumber].value) {
          return props.inputObj[theNumber].value;
        }
        if (subsObj[theNumber]) {
          // return `[${subsObj[theNumber]}]`
          switch (subsObj[theNumber]) {
          case 'client':
            return `${props.client_name}`;
          case 'associate':
            return `${props.associate}`;
          default:
            return `[${subsObj[theNumber]}]`;
          }
        }
        return '[N/A]';
      });
    }
  };

  const valueMatchPopConfirm = () => {
    const itemToReturn = whatsAppReplacementFormatter(props.selected);
    if (itemToReturn) {
      return itemToReturn;
    }
    return '';
  };

  const valueMatchReplace = () => {
    const heyArray = [];
    Object.keys(props.inputObj).forEach(key => {
      // key is going to be 1, 2, 3, 4
      heyArray.push(inputSwitch(props.inputObj[key], key));
    });
    const itemToReturn = heyArray;
    if (itemToReturn) {
      return (
        <div className="flex-col-center" style={{ width: '104%' }}>
          {itemToReturn}
        </div>
      );
    }
    return null;
  };

  const inputSwitch = (obj, key) => {
    switch (obj.type) {
      case 'date':
        return (
          <Input
            onChange={e =>
              props.setInputObj({ ...props.inputObj, [key]: { ...props.inputObj[key], value: e.target.value } })
            }
            key={key}
            value={obj.value}
            placeholder={obj.type}
            className="m-btm-15"
            maxLength={50}
          />
        );
      case 'product':
        return (
          <Input
            onChange={e =>
              props.setInputObj({ ...props.inputObj, [key]: { ...props.inputObj[key], value: e.target.value } })
            }
            key={key}
            value={obj.value}
            placeholder={obj.type}
            className="m-btm-15"
            maxLength={50}
          />
        );
      case 'interval':
        return (
          <Input
            onChange={e =>
              props.setInputObj({ ...props.inputObj, [key]: { ...props.inputObj[key], value: e.target.value } })
            }
            key={key}
            value={obj.value}
            placeholder={obj.type}
            className="m-btm-15"
            maxLength={50}
          />
        );
      default:
        return null;
    }
  };

  const popConfirmSave = () => {
    if (inputSwitchValueFilled()) {
      if (msgText) {
        sendMessage();
        props.setSelected({});
      }
    } else {
      notificationError('Please enter a placeholder!');
    }
  };

  const inputSwitchValueFilled = () => {
    const arrayInputs = [];
    Object.keys(props.inputObj).forEach(key => {
      arrayInputs.push(inputSwitch(props.inputObj[key], key));
    });
    const allNull = arrayInputs.every(element => element === null);
    const filled = arrayInputs.every(element => element === null)
      ? null
      : arrayInputs.filter(obj => obj !== null)[0].props.value;
    if (filled) {
      return true;
    }
    if (allNull) {
      return true;
    }
    return false;
  };

  const whatsAppTitleChange = () => {
    const arrayInputs = [];
    Object.keys(props.inputObj).forEach(key => {
      arrayInputs.push(inputSwitch(props.inputObj[key], key));
    });
    const allNull = arrayInputs.every(element => element === null);
    if (allNull) {
      return true;
    }
    return false;
  };

  const inboxWhatsApp = () => {
    if (!WhatsAppTimer(props.WA_receive)) {
      // Template mode - show placeholder inputs
      return (
        <Modal
          key={props.WA_receive}
          title={whatsAppTitleChange() ? 'Message Preview' : 'Enter Placeholders'}
          open
          onCancel={props.closeTheStuff}
          onOk={popConfirmSave}
          okText="SEND"
          cancelText="CANCEL"
          destroyOnClose
          width={404}
          centered
        >
          <div className="m-top-15">
            <Input.TextArea
              value={valueMatchPopConfirm()}
              className="bg-offwhite fs-13"
              style={{ height: '100px' }}
              readOnly
              variant="borderless"
            />
            {valueMatchReplace()}
          </div>
        </Modal>
      );
    }
    // Free-form message mode
    return (
      <Modal
        title="Send a Message"
        open
        onCancel={props.closeTheStuff}
        onOk={sendMessage}
        okText="SEND"
        cancelText="CANCEL"
        destroyOnClose
        width={630}
        centered
      >
        <div className="m-top-15">
          <TextAreaWithActions
            styleProps={{
              height: '18vh',
              width: '100%',
              borderRadius: '3px',
            }}
            containerStyleProps={{}}
            val={msgText}
            changeHandler={setMsgText}
            fileData={fileData}
            fileDispatch={fileDispatch}
            configObj={configObj}
            client={props.client}
            reviewLink={reviewLink}
          />
        </div>
      </Modal>
    );
  };

  useEffect(() => {
    const fullText = whatsAppReplacementFormatter(props.selected);
    if (fullText) {
      setMsgText(fullText);
    }
  }, [valueMatchPopConfirm]);

  return inboxWhatsApp();
};
const mapStateToProps = state => ({
  auth: state.auth,
  client: { ...state.client },
});

export default connect(mapStateToProps, {})(WhatsAppModal);

const ImageCard = props => {
  return (
    <div key={props.ind} className="pos-rel w-67 h-67 m-right-15">
      <FontAwesomeIcon
        className="pos-abs fs-24 bg-white circle gray"
        icon={['far', 'times-circle']}
        style={{
          top: '-12px',
          right: '-12px',
          border: '2px solid white',
        }}
        onClick={() => props.imageDeleteHandler(props.ind)}
      />
      <div className="w-67 h-67" style={{ overflow: 'hidden' }}>
        <img src={props.imageUrl} className="h-67 border-r4" alt="#" />
      </div>
    </div>
  );
};
